'use client';

import { useEffect } from 'react';

import AuthSessionErrorPanel from '@/components/auth/AuthSessionErrorPanel';
import { RouteFallback } from '@/components/ui/RouteFallback';
import {
  NETWORK_RECOVERY_ERROR_MESSAGE,
  SESSION_VALIDATION_ERROR_MESSAGE,
  getSafeErrorMessage,
} from '@/lib/auth/sessionErrors';

type GlobalErrorProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

const GlobalError = ({ error, reset }: GlobalErrorProps) => {
  useEffect(() => {
    console.error(error);
  }, [error]);

  const safeMessage = getSafeErrorMessage(error.message);

  const content =
    safeMessage === SESSION_VALIDATION_ERROR_MESSAGE || safeMessage === NETWORK_RECOVERY_ERROR_MESSAGE ? (
      <AuthSessionErrorPanel description={safeMessage} />
    ) : (
      <RouteFallback
        title="Something went wrong"
        description="SportsFi could not load this page. Try again, or return to SportsFi."
        onRetry={reset}
      />
    );

  return (
    <html lang="en">
      <body>{content}</body>
    </html>
  );
};

export default GlobalError;
